import { useRef, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { PageLayout } from "@/components/layout";
import { HeroSection } from "@/components/home";
import { MobileCTABar, LazySection } from "@/components/shared";

// Lazy load ParallaxBackground - uses heavy framer-motion hooks (useScroll, useTransform)
const ParallaxBackground = lazy(() => 
  import("@/components/home/ParallaxBackground").then(m => ({ default: m.ParallaxBackground }))
);

const Index = () => {
  const navigate = useNavigate();
  const ctaSectionRef = useRef<HTMLElement>(null);

  return (
    <PageLayout withMobileCTAPadding>
      <Suspense fallback={<div className="fixed inset-0 -z-10 bg-background" />}>
        <ParallaxBackground />
      </Suspense>
      
      <HeroSection 
        onBrowseClick={() => navigate("/shop")}
        onLearnMoreClick={() => navigate("/faq")}
      />

      {/* Below-the-fold sections use intersection observer for true lazy loading */}
      <LazySection
        component={() => import("@/components/home/HowItWorksSection").then(m => ({ default: m.HowItWorksSection }))}
        fallbackHeight="300px"
      />

      <LazySection
        component={() => import("@/components/home/StorePreviewSection")}
        fallbackHeight="400px"
      />

      <LazySection
        component={() => import("@/components/home/WhatsInsideSection").then(m => ({ default: m.WhatsInsideSection }))}
        fallbackHeight="400px"
      />

      <LazySection
        component={() => import("@/components/home/FeaturesSection").then(m => ({ default: m.FeaturesSection }))}
        fallbackHeight="300px"
      />

      <LazySection
        component={() => import("@/components/home/StatsSection").then(m => ({ default: m.StatsSection }))}
        fallbackHeight="200px"
      />

      <LazySection
        component={() => import("@/components/home/TestimonialsSection").then(m => ({ default: m.TestimonialsSection }))}
        fallbackHeight="300px"
      />

      <LazySection
        component={() => import("@/components/home/CTASection")}
        fallbackHeight="200px"
        componentProps={{ onViewAllPacksClick: () => navigate("/shop") }}
        sectionRef={ctaSectionRef}
      />

      <MobileCTABar
        variant="browse" 
        onAction={() => navigate("/shop")}
        ctaSectionRef={ctaSectionRef}
      />
    </PageLayout>
  );
};

export default Index;